import React from 'react';
import { Context } from '../../App';
import Resource, { ResourceModel } from '../../model/resource';
import ModelInput from '../../base-components/ModelInput';
import Card from '../../base-components/Card';
import useModel from '../../base-components/hooks/useModel';
import EditorParent from '@/base-components/EditorParent';
import { deleteResource } from '@/api/resource-controller';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from '@/generic/config';

const ResourcePage: React.FC = () => {
    const { translations } = React.useContext(Context);
    const { model, toolbar } = useModel<Resource>(ResourceModel);
    const navigate = useNavigate();

    const title = model.isNew
        ? translations.systemSettings.resource.create
        : `${translations.model.resource.search.title} — ${model.object.code} (${model.object.id})`;

    const actions = model.isNew ? [] : [
        {
            title: translations.model.resource.delete,
            onClick: async () => {
                await deleteResource(model.object);
                navigate(RoutePath.Resources);
            },
        },
    ];

    return (
        <EditorParent title={title} toolbar={toolbar} actions={actions}>
            <Card title={translations.model.resource.code} description={translations.systemSettings.resource.description}>
                <ModelInput title={translations.model.resource.code} fieldKey="code" model={model} />
                <ModelInput title={translations.common.active} fieldKey="enabled" model={model} />
            </Card>
        </EditorParent>
    );
};

export default ResourcePage;
